import { ERROR, LOADING, NOT_STARTED, SUCCESS } from '../../Constants/commonConstants';
import {
  DELETE_COMPARISON,
  DOCUMENT_COMPARE,
  DOCUMENT_COMPARE_RE_ANALYSIS,
  GET_SAVED_COMPARISON,
} from './compareTypes';

export const initialState = {
  compareStatus: NOT_STARTED,
  finalComparison: [],
  statusText: '',
  originalDocumentURL: '',
  modifiedDocumentURL: '',
  sharedURL: '',
  getSavedCompareStatus: LOADING,
  savedComparisons: {},
  remainingQuota: null,
  documentsMetaData: {},
  comparisonId: '',
  annotationData: [],
  totalComparisons: 0,
  headingsData: [],
  reAnalysisStatus: NOT_STARTED,
  comparisonResults: [],
  contradictionResults: [],
};

export const fileCompareReducer = (state = initialState, action) => {
  switch (action.type) {
    case DOCUMENT_COMPARE:
      if (action.compareStatus === SUCCESS) {
        let modification = {};
        if (action.additionalAction === DELETE_COMPARISON) {
          modification = {
            savedComparisons: {},
            getSavedCompareStatus: LOADING,
          };
        }
        return {
          ...state,
          compareStatus: SUCCESS,
          finalComparison: action.finalComparison,
          annotationData: action.annotationData,
          headingsData: action.headingsData,
          originalDocumentURL: action.originalDocumentURL,
          modifiedDocumentURL: action.modifiedDocumentURL,
          sharedURL: action.sharedURL,
          comparisonTitle: action.comparisonTitle,
          documentsMetaData: action.documentDetails,
          comparisonId: action.comparisonId,
          comparisonResults: action.comparisonResults,
          contradictionResults: action.contradictionResults,
          ...modification,
        };
      }
      if (action.compareStatus === LOADING) {
        return {
          ...state,
          compareStatus: LOADING,
        };
      }
      if (action.compareStatus === ERROR) {
        return {
          ...state,
          compareStatus: ERROR,
          statusText: action.statusText,
        };
      }
      break;
    case DOCUMENT_COMPARE_RE_ANALYSIS:
      if (action.compareStatus === SUCCESS) {
        return {
          ...state,
          reAnalysisStatus: SUCCESS,
          finalComparison: action.finalComparison,
          annotationData: action.annotationData,
          headingsData: action.headingsData,
          originalDocumentURL: action.originalDocumentURL,
          modifiedDocumentURL: action.modifiedDocumentURL,
          sharedURL: action.sharedURL,
          comparisonTitle: action.comparisonTitle,
          documentsMetaData: action.documentDetails,
          comparisonId: action.comparisonId,
        };
      }
      if (action.compareStatus === LOADING) {
        return {
          ...state,
          reAnalysisStatus: LOADING,
        };
      }
      if (action.compareStatus === ERROR) {
        return {
          ...state,
          reAnalysisStatus: ERROR,
          statusText: action.statusText,
        };
      }
      break;

    case GET_SAVED_COMPARISON:
      if (action.getSavedCompareStatus === SUCCESS) {
        return {
          ...state,
          getSavedCompareStatus: SUCCESS,
          savedComparisons: action?.savedComparisons,
          totalComparisons: action.totalComparisons,
          remainingQuota: action?.remainingQuota,
        };
      }
      if (action.getSavedCompareStatus === LOADING) {
        return {
          ...state,
          getSavedCompareStatus: LOADING,
        };
      }
      return {
        ...state,
        getSavedCompareStatus: action.statusCode,
      };

    case DELETE_COMPARISON:
      if (action.deleteComparisonStatus === SUCCESS) {
        return {
          ...state,
          deleteComparisonStatus: SUCCESS,
          savedComparisons: {},
        };
      }
      if (action.deleteComparisonStatus === LOADING) {
        return {
          ...state,
          deleteComparisonStatus: LOADING,
        };
      }
      if (action.deleteComparisonStatus === ERROR) {
        return {
          ...state,
          deleteComparisonStatus: ERROR,
        };
      }
      break;
    default:
      return state;
  }
};
